/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class BenjiKIVGameAssets {

    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_BIG_WIN_COUNT_UP = "NumbersWinCountUp_B";
    static BITMAP_FONT_SYMBOL_MULTIPLIER = "Numbers_M";
    static BITMAP_FONT_COUNT_UP_MULTIPLIER = "Numbers_MY";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FS_BACKGROUND:string = "freespinBackground";
    public static FS_BACKGROUND_WV: string = "freespinBackground_WV";
    public static SUPER_FS_BACKGROUND:string = "superFreespinBackground";
    public static BROKEN_GLASS_ANIMATION:string = "FX_Win_Shatter/WinShatter_";

    public static XSPLIT_REEL_ATTENTION:string = "Reel_Attention_X";
    public static DEAD_REEL_ATTENTION:string = "Reel_Attention_DP";
    public static STACKED_MULTIPLIERS:string[] = ["Multiplier/X2", "Multiplier/X3", "Multiplier/X4", "Multiplier/X5", "Multiplier/X6"];
    public static WILD_STACKED_MULTIPLIERS:string[] = ["Multiplier_Wild/X2", "Multiplier_Wild/X3", "Multiplier_Wild/X4", "Multiplier_Wild/X5", "Multiplier_Wild/X6"];
    public static WILD_STACKED_MULTIPLIERS_BW:string[] = ["Multiplier_Wild/X2_BW", "Multiplier_Wild/X3_BW", "Multiplier_Wild/X4_BW", "Multiplier_Wild/X5_BW", "Multiplier_Wild/X6_BW"];

    public static BIG_WIN_SPINE:string = "spine/Big_Win.json";
    public static RESPIN_SPINE:string = "spine/Respin.json";
    public static INITIAL_WIN_SYMBOL_SPINE:string = "spine/Win.json";
    public static RING_GIRL_SPINE:string = "spine/Ring_Girl.json";
    public static INTRO_SPINE:string = "spine/Intro_Screen.json";
    public static X_SPLIT_SPINE:string = "spine/X_Split.json";
    public static MAX_WIN_SPINE:string = "spine/Max_Win.json";
    public static NO_WIN_SPINE:string = "spine/No_Win.json";
    public static FS_INTROS_SPINE:string = "spine/FS_Intros.json";
    public static SCATTER_OVERLAY_SPINE:string = "spine/Scatter_Overlay.json";
    public static SCATTER_SPINE:string = "spine/Scatter.json";
    public static INDIVIDUAL_WIN_SYMBOL_SPINE:string = "spine/Toggle.json";
    public static SPLIT_SYMBOL_SPINE:string = "spine/X_Split.json";
    public static PLUS_2_SPINE:string = "spine/Plus_2.json";

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [],

        main : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset(BenjiKIVGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(BenjiKIVGameAssets.BITMAP_FONT_BIG_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp_B.fnt"),
                    new BitmapFontAsset(BenjiKIVGameAssets.BITMAP_FONT_SYMBOL_MULTIPLIER, "fonts/bitmapfonts/Numbers_M.fnt"),
                    new BitmapFontAsset(BenjiKIVGameAssets.BITMAP_FONT_COUNT_UP_MULTIPLIER, "fonts/bitmapfonts/Numbers_MY.fnt")
                ]
            },
            {
                name : "backgrounds",
                assets : [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                    new TextureAsset("backgroundsJpeg3", "sheets/backgroundsJpeg/backgroundsJpeg3.json"),
                    new TextureAsset("backgroundsJpeg4", "sheets/backgroundsJpeg/backgroundsJpeg4.json")
                ]
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset(BenjiKIVGameAssets.PLUS_2_SPINE, BenjiKIVGameAssets.PLUS_2_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.SCATTER_SPINE, BenjiKIVGameAssets.SCATTER_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.SCATTER_OVERLAY_SPINE, BenjiKIVGameAssets.SCATTER_OVERLAY_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.FS_INTROS_SPINE, BenjiKIVGameAssets.FS_INTROS_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.MAX_WIN_SPINE, BenjiKIVGameAssets.MAX_WIN_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.NO_WIN_SPINE, BenjiKIVGameAssets.NO_WIN_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.X_SPLIT_SPINE, BenjiKIVGameAssets.X_SPLIT_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.INTRO_SPINE, BenjiKIVGameAssets.INTRO_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.RING_GIRL_SPINE, BenjiKIVGameAssets.RING_GIRL_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.BIG_WIN_SPINE, BenjiKIVGameAssets.BIG_WIN_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.RESPIN_SPINE, BenjiKIVGameAssets.RESPIN_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.INITIAL_WIN_SYMBOL_SPINE, BenjiKIVGameAssets.INITIAL_WIN_SYMBOL_SPINE),
                    new SpineAsset(BenjiKIVGameAssets.INDIVIDUAL_WIN_SYMBOL_SPINE, BenjiKIVGameAssets.INDIVIDUAL_WIN_SYMBOL_SPINE)
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json")
                ],
                animations: {
                    "bullet" : "BW_Particles/Bullet/Bullet_",
                    "tooth" : "BW_Particles/Tooth/Tooth_",
                    "money1" : "BW_Particles/Dollar/Dollar_A",
                    "money2" : "BW_Particles/Dollar/Dollar_B",
                    "money3" : "BW_Particles/Dollar/Dollar_C"
                }
            },
            {
                name : "mainHighMobile",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHighMobile0", "sheets/mainHighMobile/mainHighMobile0.json")
                ]
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json")
                ]
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations : {}
            },
            {
                name : "symbolsJpeg",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsJpeg0", "sheets/symbolsJpeg/symbolsJpeg0.json")
                ],
                animations : {}
            }
        ]
    };
}
